'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const useFirstVisible = (element) => {
  const [isVisible, setState] = React.useState(false);
  const counter = React.useRef(0);
  React.useEffect(() => {
    if ((element == null ? void 0 : element.current) && !counter.current) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !counter.current) {
          setState(entry.isIntersecting);
          observer.unobserve(element.current);
          counter.current++;
        }
      });
      observer.observe(element.current);
      return () => {
        if (element == null ? void 0 : element.current) {
          observer.unobserve(element.current);
        }
      };
    }
  }, [element]);
  return isVisible;
};

exports.useFirstVisible = useFirstVisible;
